<script setup lang="ts">
	import {msg} from "@/i18n/Message";
	import {ref} from 'vue';
	import ErrorMsg from "./ErrorMsg.vue";
	import { useBaseStep } from './BaseStep';
	import { useCrmInstallData } from '../CrmInstallData';
	import SymIcon from "@fd/helpers/SymIcon.vue";
	import ProgressButton from "./ProgressButton.vue";
	
	
	const emit = defineEmits(['nextStep','complete']);
	const props = defineProps({
		form: Object,
		restApi: String,
		endPoint: { type: String, default: "/done" }
	});
	
	const { errorMessage, isError, progress, sendForm, nextStep } = useBaseStep(props,emit,validateForm);
	
	function validateForm(): boolean {
		return true;
	}
	
</script>
<template>
	<div>
	<div class="formTitle">{{msg("install.title.done")}}</div>
	<table border="0" cellspacing="0" class="formTable">
		<tr>
			<td><error-msg :show="isError" :msg="errorMessage"/></td>
		</tr>
		<tr>
			<td style="padding-top:10px">
				<button @click="nextStep('User')" class="sbutton">
					<sym-icon name="page-prev-16-full" style="padding-right: 10px;"/>{{msg("install.butt.back")}}
				</button>
				&nbsp;	
				<progress-button @click="sendForm(form,'Install')" :progress="progress"
					class="button" icon="checkmark-circle-16-full">
					{{msg('butt.finish')}}
				</progress-button>
			</td>
		</tr>
	</table>
	</div>
</template>

